// src/pages/Proposta/SubmeterPropostaPage.jsx
import React from 'react';
import PropostaForm from '../../components/Proposta/PropostaForm';

const SubmeterPropostaPage = () => {
    return (
        <div>
            <h1>Submeter Proposta</h1>
            <PropostaForm onSuccess={() => alert('Proposta submetida com sucesso!')} />
        </div>
    );
};

export default SubmeterPropostaPage;
